import { useRouter } from 'next/router';

import React, {
    useState,
    createContext,
    useRef,
    useEffect,
    useContext,
} from 'react';
import { useUpdateEffect } from 'usehooks-ts';
import { IProduct } from '../utils/types/product';
import {
    IFilterOptionData,
    IPaginationInfo,
    ITaxonomyContext,
    ITaxonomyContextProps,
    ITaxonomyContextValue,
    TProducts,
} from '../utils/types/taxonomy';
import createCtx from './createCtx';
import TSTaxonomy from '../utils/typesense/taxonomy';

export const [useTaxonomyContext, TaxonomyCtxProvider] =
    createCtx<ITaxonomyContextValue>();

export default function TaxonomyContext(props: ITaxonomyContextProps) {
    const router = useRouter();
    const [priceFilterOpen, setPriceFilterOpen] = useState<boolean>(true);
    const [priceState, setPriceState] = useState<IFilterOptionData | null>(
        null
    );

    const { defaultSortBy } = props;

    const [typeFilterOpen, setTypeFilterOpen] = useState<boolean>(false);
    const [typeState, setTypeState] = useState<IFilterOptionData | null>(null);

    const [favouriteFilterOpen, setFavouriteFilterOpen] =
        useState<boolean>(false);
    const [favouriteState, setFavouriteState] =
        useState<IFilterOptionData | null>(null);

    const [ocassionFilterOpen, setOcassionFilterOpen] =
        useState<boolean>(false);
    const [ocassionState, setOcassionState] =
        useState<IFilterOptionData | null>(null);

    const [suitableForFilterOpen, setSuitableForFilterOpen] =
        useState<boolean>(false);
    const [suitableForState, setSuitableForState] =
        useState<IFilterOptionData | null>(null);

    const [sortByState, setSortByState] = useState<IFilterOptionData>(
        defaultSortBy ? defaultSortBy : TSTaxonomy.sortOptions[0]
    );

    const [filterOpen, setFilterOpen] = useState(false);
    const [sortByOpen, setSortByOpen] = useState(false);

    /**
     * Reset props on url slug change
     */
    useUpdateEffect(() => {
        setPriceState(null);
        setTypeState(null);
        setOcassionState(null);
        setSuitableForState(null);
        setFavouriteState(null);
    }, [router.asPath]);

    return (
        <TaxonomyCtxProvider
            value={{
                priceFilter: [
                    priceFilterOpen,
                    setPriceFilterOpen,
                    priceState,
                    setPriceState,
                ],
                typeFilter: [
                    typeFilterOpen,
                    setTypeFilterOpen,
                    typeState,
                    setTypeState,
                ],
                favouriteFilter: [
                    favouriteFilterOpen,
                    setFavouriteFilterOpen,
                    favouriteState,
                    setFavouriteState,
                ],
                ocassionFilter: [
                    ocassionFilterOpen,
                    setOcassionFilterOpen,
                    ocassionState,
                    setOcassionState,
                ],
                suitableForFilter: [
                    suitableForFilterOpen,
                    setSuitableForFilterOpen,
                    suitableForState,
                    setSuitableForState,
                ],
                sortByState: [sortByState, setSortByState],
                slideOverFilter: [filterOpen, setFilterOpen],
                slideOverSort: [sortByOpen, setSortByOpen],
            }}
        >
            {props.children}
        </TaxonomyCtxProvider>
    );
}
